<div class="data" *ngFor="let data of mapData">
    <div class="data-block">
        <p>Group</p>
        <p>:</p>
        <p>{{data.group}}</p>
    </div>

    <div class="data-block">
        <p>Name</p>
        <p>:</p>
        <p>{{data.name}}</p>
    </div>
    <div class="data-block">
        <p>Type</p>
        <p>:</p>
        <p>{{data.type}}</p>
    </div>
</div>